export default "__VITE_ASSET__B$cKzD2n__"